import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import GroupLinkItemSortable from './groupLinkItemSortable';

const GroupLinksSortable = SortableContainer((props) => {
  return (
    <div className="groupLinks-wrapper">
      {
        props.items && props.items.map((groupLinkItem, index) => (
          <GroupLinkItemSortable
            key={`groupLinkItem-${index}-${groupLinkItem.label}`}
            index={index}
            groupLinkIndex={index}
            value={groupLinkItem}
            deleteItem={props.deleteItem}
            hideItem={props.hideItem}
          />
        ))
      }
    </div>
  )
});

export default GroupLinksSortable;


// WEBPACK FOOTER //
// ./src/app/screens/sections/groupsSection/groupLinksSection/groupLinksSortable.js